import { useState, useEffect } from "react";
import Loader from "./component/Loader";
import App from "./App";

export default function AppWrapper() {
  const MIN_TIME = 1800; // 1.8 sec minimum
  const [loading, setLoading] = useState(true);
  const [appReady, setAppReady] = useState(false);

  // detects when React is ready
  useEffect(() => {
    setAppReady(true);
  }, []);

  // ensures minimum visible time
  useEffect(() => {
    const timer = setTimeout(() => {
      if (appReady) setLoading(false);
    }, MIN_TIME);

    if (appReady) {
      setLoading(false);
      clearTimeout(timer);
    }

    return () => clearTimeout(timer);
  }, [appReady]);

  return loading ? <Loader fading={!loading} /> : <App />;
}
